import * as React from 'react';
import { getBundleProductTitle } from '../../../../utils/get-bundle-product-title.js';
import ConfigurationSummaryDivider from '../../../steps/components/ConfigurationSummaryDivider/ConfigurationSummaryDivider.js';
import ConfigurationSummaryRow from '../../../steps/components/ConfigurationSummaryRow/ConfigurationSummaryRow.js';
import FrameInformation from '../../../steps/components/FrameInformation/FrameInformationContainer.js';

const ConfigurationSummary = ({ labels , frame , addOn , lensType , lensPackage , bundlePrice , isPhone , isSmallScreen , hasVisitedStepLensPackage , hasVisitedStepAddOn ,  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, frame && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: /*#__PURE__*/ React.createElement(FrameInformation, {
            showImage: isPhone,
            textOrientation: isPhone ? 'vertical' : 'horizontal'
        }),
        price: frame.price
    }), /*#__PURE__*/ React.createElement("div", {
        className: "glasses-configuration-summary",
        "data-t": "configuration-summary"
    }, lensType && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensType,
        value: getBundleProductTitle(lensType),
        price: lensType.price,
        discountText: lensType.discountText
    })), hasVisitedStepLensPackage && lensPackage && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensPackage,
        value: lensPackage.title,
        price: lensPackage.price,
        discountText: lensPackage.discountText
    }), hasVisitedStepAddOn && addOn && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.addOn,
        value: getBundleProductTitle(addOn),
        price: addOn.price,
        discountText: addOn.discountText
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.totalPrice,
        price: bundlePrice,
        priceSize: "medium"
    })))
;
var ConfigurationSummary$1 = ConfigurationSummary;

export { ConfigurationSummary$1 as default };
//# sourceMappingURL=ConfigurationSummary.js.map
